function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'cranberry': 'rgb(220, 29, 68)','stone': 'rgb(222, 205, 190)','dark-navy': 'rgb(29, 37, 69)','navy': 'rgb(45, 54, 76)','orange': 'rgb(255, 102, 0)','athletic-heather': 'rgb(202, 202, 202)','team-royal': 'rgb(45, 64, 125)','carbon-grey': 'rgb(199, 195, 190)','white': 'rgb(254, 254, 254)','spruce': 'rgb(24, 58, 49)','baby-pink': 'rgb(255, 198, 205)','gold': 'rgb(255, 169, 19)','heather-grey': 'rgb(161, 159, 155)','black': 'rgb(12, 12, 12)','berry': 'rgb(192, 39, 115)','athletic-heather': 'rgb(206, 206, 204)','ocean-blue': 'rgb(169, 223, 246)','yellow': 'rgb(255, 214, 103)','royal': 'rgb(34, 41, 133)','olive': 'rgb(65, 64, 29)','navy-blazer': 'rgb(23, 31, 44)','dusty-rose': 'rgb(245, 147, 130)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
